<script setup lang="ts">
import type { Property } from '~/core/entities/property';

import { grammarInflection } from '~~/utils';

import { HeroButton } from '~/components/HeroButton';

import IconMaterialSymbolsLightImageOutline from '~icons/material-symbols-light/image-outline';
import IconMaterialSymbolsLightMapOutline from '~icons/material-symbols-light/map-outline';
import IconMaterialSymbolsPlayArrowOutline from '~icons/material-symbols-light/play-arrow-outline';

interface PropertyHeroActionButtonsDeprecatedProps {
	property: Property | null;
	numberOfImages: number;
	numberOfVideos: number;
	shouldShowSimilarPropertyCta: boolean;
}

interface PropertyHeroActionButtonsDeprecatedEmits {
	'photo-clicked': [];
	'video-clicked': [];
	'map-clicked': [];
	'similar-clicked': [];
}

defineProps<PropertyHeroActionButtonsDeprecatedProps>();
defineEmits<PropertyHeroActionButtonsDeprecatedEmits>();
</script>

<template>
	<div
		class="no-scrollbar absolute inset-x-0 bottom-4 z-20 flex w-full items-center justify-start gap-2 overflow-x-auto px-4 md:bottom-5 md:w-fit md:overflow-x-hidden md:px-5 lg:bottom-6 lg:gap-3 lg:px-12"
	>
		<HeroButton
			variant="transparent"
			class="max-w-32 text-sm"
			@click="$emit('photo-clicked')"
		>
			<template #icon>
				<IconMaterialSymbolsLightImageOutline class="size-5" />
			</template>
			<slot name="photo-modal-cta-text" />
		</HeroButton>

		<HeroButton
			v-if="numberOfVideos"
			variant="transparent"
			class="max-w-32 text-sm"
			@click="$emit('video-clicked')"
		>
			<template #icon>
				<IconMaterialSymbolsPlayArrowOutline class="size-5" />
			</template>
			{{ numberOfVideos }}
			{{ grammarInflection(numberOfVideos, 'vídeo', 'vídeos') }}
		</HeroButton>

		<HeroButton
			variant="transparent"
			class="max-w-32 text-sm font-semibold"
			@click="$emit('map-clicked')"
		>
			<template #icon>
				<IconMaterialSymbolsLightMapOutline class="size-5" />
			</template>
			Mapa
		</HeroButton>

		<HeroButton
			v-if="shouldShowSimilarPropertyCta"
			variant="transparent"
			class="max-w-32 text-sm font-semibold"
			@click="$emit('similar-clicked')"
		>
			<template #icon>
				<IconPilarHouseCheck class="size-5" />
			</template>
			Semelhantes
		</HeroButton>
	</div>
</template>
